/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { InputGroup, Button, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import { getBuyersUrl, getBuyerHeaders } from 'shared/http/';
import Validators from 'shared/validators/';
import store from 'features/store';
import AuthService from 'shared/services/authService';
import './ForgotPassword.scss';
/**

    verify username to send verification link on forgot password

    @Author Narmadha

    @param

    @return forgot password html code

    **/

export class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.timeoutInterval = null;
        this.state = {
            form: {
                email: { value: '', error: '', validators: [Validators.required(), Validators.email()] }
            },
            valid: true,
            disableBtn: true,
            reactivationBtn: false,
            reactivationMsg: '',
            loading: false,
            innerWidth: window.innerWidth,
            success: false,
            headerHeight: 101
        };
        this.forgotHeader = createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    /**
    * 
    * Called after component mount
    * 
    */
    componentDidMount() {

        /* Adding event listenr for resize */
        window.addEventListener('resize', this.updateDimensions);

        /* Setting which want to show. Sign-In or Sign-Up page */
        this.setState({
            activeKey: this.props.toggleSignInModal.mode
        });

        this.updateDimensions();
    }
    
    componentDidUpdate() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    /**
     * 
     * Called when resize the screen.
     * 
     */
    updateDimensions = () => {
        const header = this.forgotHeader.current;
        this.setState({
            ...this.state,
            innerWidth: window.innerWidth,
            headerHeight: header.clientHeight
        });
    }

    /* validation for input changes */
    handleChange = (event) => {
        let inputError = '';
        for (let validator of this.state.form[event.target.name].validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

        this.setState({
            ...this.state,
            valid: inputError.length > 0,
            disableBtn: true,
            form: {
                ...this.state.form,
                [event.target.name]: {
                    ...this.state.form[event.target.name],
                    value: event.target.value,
                    error: inputError
                }
            }
        }, () => {
            if (!this.state.valid) {
                if (this.timeoutInterval) {
                    clearTimeout(this.timeoutInterval);
                }
                this.timeoutInterval = setTimeout(() =>  {
                    this.verifyMail(event);
                }, 400);
            }
        });
    }


    verifyMail = (event) => {
        const data = {
            "data": {
                "email": this.state.form.email.value
            }
        };
        AuthService.checkDetails(data).then(res => {
            this.setState({
                disableBtn: false,
            })

        }).catch(error => {
            if (error.ctbidserrorcode == "CBBY001") {
                this.setState({
                    showReactivationModel: true,
                    // valid: true,
                    disableBtn: true,

                })
            }else if(error.ctbidserrorcode == "CBBY009" || error.ctbidserrorcode == "CBBY010"){
                this.setState({
                    disableBtn: false,
                })
            }
            else {
                this.setState({
                    ...this.state,
                    form: {
                        ...this.state.form,
                        email: {
                            ...this.state.form.email,
                            error: error.message
                        }
                    }

                })
            }
        })
    }

    closeReactivationModel = () =>{
        this.setState({
            ...this.state,
            form:{
                ...this.state.form,
                email: {
                    ...this.state.form.email,
                    value: ''
                }
            },
            showReactivationModel: false,
        },()=>{
            console.log(this.state.form.email.value)
        })
    }
    

    reactivation = () => {
        const data =  {
            "email": this.state.form.email.value
        }
        this.setState({
            reactivationBtn: true
        })

        AuthService.reActivation({"data" : data}).then(res => {
            this.setState({
                ...this.state,
                reactivationMsg: 'Reactivation mail sent successfully'
            });

        setTimeout(() => {
          this.setState({
            ...this.state,
            reactivationBtn: false,
            form:{
                ...this.state.form,
                email: {
                    ...this.state.form.email,
                    value: ''
                }
            },
            reactivationMsg: '',
            showReactivationModel: false,
          })
            
        }, 2000);

        

        }).catch(error => {
            this.setState({
                reactivationBtn: false,

            })
        })
    }
    /* called when send password link button clicked */
    handleSubmit = async () => {
        this.setState({ loading: true });
        await axios.post(getBuyersUrl('/api/v1/buyer/user/reset/password '), JSON.stringify({ data: { email: this.state.form.email.value } }), getBuyerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.setState({ loading: false, success: true });
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                // TODO: Error message handle
            });
    }
    handleClose = () => {
        store.dispatch({ type: 'TOGGLE_FORGOT_PASSWORD', payload: { open: false, mode: 'Forgot-Password' } });
    }

    singInOpen = () => {
        this.handleClose();
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
    }

    backIconClick = () => {
        this.state.success ? this.handleClose() : this.singInOpen();
    }

    render() {
        return (
            <div className="forgot-password-conatiner">
                <Modal id="forgot-password-modal"
                    show={this.props.toggleForgotPasswordModal?.open} animation={false} centered={this.state.innerWidth < 769}
                    size="lg" onHide={this.handleClose} className={`${this.state.innerWidth > 768 ? 'right fade' : ''}`}
                    aria-labelledby="contained-modal-title-vcenter"
                >
                    <Modal.Body className="h-100">
                        <div className="header" ref={this.forgotHeader}>
                            <div className="d-flex align-items-center">
                                <div className="back-icon clickable" onClick={this.backIconClick}>
                                    <i className="fas fa-arrow-left"></i>
                                </div>
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    {
                                        this.state.success ? null : <span className="ml-2 left-text clickable" onClick={this.singInOpen}>Back to Signin</span>
                                    }
                                    <span className="ml-2 right-text clickable" onClick={this.handleClose}>Back to Home</span>
                                </div>
                            </div>
                        </div>
                        <div className="forgot-password-form" style={{ height: `calc(100% - ${this.state.headerHeight}px)` }}>
                            <div className={`d-flex align-items-center ${this.state.success ? 'flex-column justify-content-between overflow-auto' : 'justify-content-center'} h-100`}>
                                {
                                    this.state.success ? <div className="success-message d-flex flex-column justify-content-center">
                                        <div className="d-flex flex-column justify-content-between">
                                            <div className="icon text-center">
                                                <i className="fas fa-check-circle fa-3x"></i>
                                            </div>
                                            <div className="link h4 text-center">
                                                A Password Reset Link Has Been Sent
                                            </div>
                                            <div className="message h4 text-center">
                                                If your email was found for an active account, you will receive an email with a link to reset your password.
                                            </div>
                                        </div>
                                    </div> :
                                        <div className="input-field">
                                            <div className="h5 info text-bold">
                                                {
                                                    this.props.toggleForgotPasswordModal.mode === 'Forgot-Password' ? 'Forgot Password? OR Never received your verification email?' : 'Existing User'
                                                }
                                            </div>
                                            <InputGroup className="remove-mb">
                                                <Form.Control autoFocus id="email" value={this.state.form.email.value} name="email" type="email" className="border-radius" onChange={(event) => this.handleChange(event)} placeholder="Enter your account email address" />
                                                <InputGroup.Append>
                                                    <Button variant="secondary" type="button" disabled={this.state.disableBtn} onClick={() => this.handleSubmit()}>Send</Button>
                                                </InputGroup.Append>
                                            </InputGroup>
                                            <div className="text">
                                                {
                                                    this.state.form.email.error ? <small className="text-danger">{this.state.form.email.error}</small> : <small className="text-muted">
                                                        {
                                                            this.props.toggleForgotPasswordModal.mode === 'Forgot-Password' ?
                                                                "If you have an active account with us using this email address, we will send you an email with a link to set a new password." :
                                                                "We will send you a link where you can reset your password."
                                                        }
                                                    </small>
                                                }
                                            </div>
                                        </div>
                                }
                                {
                                    this.state.success ?
                                        <div className="message h5 text-center bottom-message">
                                            Tip: If you didn�t receive an email from <span>noreply@ctbids.com</span> please check your spam or junk folder.
                                        </div> : null
                                }
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.showReactivationModel} className="change-mobile-modal" onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body>
                            <div >
                                <p className='text-center'>This email address is already associated with an account that has been deleted. Would you like reactivate your account?</p>

                                {this.state.reactivationMsg && <div className='text-success text-center mt-3'>
                                    {this.state.reactivationMsg}
                                </div>}

                                <div className="d-flex justify-content-center align-items-center mt-3">
                                    <Button className='me-2' onClick={() => this.closeReactivationModel()}>No</Button>
                                    <Button disabled={this.state.reactivationBtn} variant="secondary mx-2" onClick={() => this.reactivation()}>Yes</Button>
                                </div>
                            </div>
                        
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}